import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var User = namespace('user');
import LogoutPrompt from './components/logoutPrompt.vue';
import ConfirmLogout from './components/confirmLogout.vue';
import Completed from './components/completed.vue';

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    var _a;

    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.current = _this.$enum.mine.LogoutStepEnum.LogoutPrompt;
    _this.stepContent = (_a = {}, _a[_this.$enum.mine.LogoutStepEnum.LogoutPrompt] = 'LogoutPrompt', _a[_this.$enum.mine.LogoutStepEnum.ConfirmLogout] = 'ConfirmLogout', _a[_this.$enum.mine.LogoutStepEnum.Completed] = 'Completed', _a);
    return _this;
  }

  Object.defineProperty(ProtocolLog.prototype, "isLoading", {
    get: function get() {
      if (this.step === this.$enum.mine.LogoutStepEnum.Completed) {
        return false;
      }

      return !this.isInactive;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ProtocolLog.prototype, "isInactive", {
    get: function get() {
      var _a;

      return ((_a = this.userInfo) === null || _a === void 0 ? void 0 : _a.customer_status) === this.$enum.mine.UserStatus.INACTIVE;
    },
    enumerable: false,
    configurable: true
  });

  ProtocolLog.prototype.onIsInactiveChange = function () {
    if (!this.$util.isEmpty(this.userInfo.customer_status) && !this.isInactive && this.step !== this.$enum.mine.LogoutStepEnum.Completed) {
      this.$router.push({
        name: 'IndexPage'
      });
    }
  };

  ProtocolLog.prototype.handleNext = function (step) {
    this.current = step;
  };

  ProtocolLog.prototype.created = function () {
    if (!this.$util.isEmpty(this.step)) {
      this.current = this.step;
    }

    this.onIsInactiveChange();
  };

  __decorate([User.State('userInfo')], ProtocolLog.prototype, "userInfo", void 0);

  __decorate([Prop({
    type: Number,
    "default": undefined
  })], ProtocolLog.prototype, "step", void 0);

  __decorate([Watch('isInactive')], ProtocolLog.prototype, "onIsInactiveChange", null);

  ProtocolLog = __decorate([Component({
    components: {
      LogoutPrompt: LogoutPrompt,
      ConfirmLogout: ConfirmLogout,
      Completed: Completed
    }
  })], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;